import { PopupBuilder } from '@mobile/views/Relation/Shared/Popup/builder/PopupBuilder'

import ChallengePopupDetails from './ChallengePopupDetails.vue'

export const ChallengePopup = new PopupBuilder('Challenge')
  .appendBody(ChallengePopupDetails)
  .build()
